import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { AppServiceManager } from "common/services/appServiceManager";
import branches from '../../shared/data/branches.json'
import globalVariable from "../../../globalVariable/globalVariable.json";
@Component({
  selector: 'enquiry',
  templateUrl: './enquiry.component.html',
  styleUrls: ['./enquiry.component.css']
})
export class EnquiryComponent {
  errorExempleNumber: string;
  gender = "M";
  fullName: any;
  emailAdress: string;
  isVaccinated: boolean = false;
  mobile: any;
  expectedJoining: any;
  company: string;
  branch: string;
  address: any;
  selectedBranch: { _id: string; contactPersonEmail: string; address: string; phone: string; company: { _id: string; bannerImage: string; websiteUrl: string; companyName?: undefined; }; } | { _id: string; contactPersonEmail: string; address: string; phone: string; company: { _id: string; bannerImage: string; websiteUrl: string; companyName: string; }; };
  message: string;
  isSuccess: boolean;
  isError: boolean;
  branches = branches;
  loading: boolean = false;
  isMessage: boolean;
  formattedNumber:string = '';


  constructor(
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe(params => {
        console.log('company:', params.get('company'));
        console.log('branch:', params.get('branch'));
        this.company = params.get('company');
        this.branch = params.get('branch');

        this.branches = this.branches.filter(branch => branch._id == this.branch);
        if (this.branches.length > 0) {
          this.selectedBranch = this.branches[0];
          // console.log( this.selectedBranch);
        }

        else {
          console.log("Sorry, Something went wrong.");

        }
      });
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;

  }
  errorMsgClose() {
    this.isMessage = false;
    this.isError = false;
    this.isSuccess = false;
  }
  submit(form: any) {

    if (form.valid) {
    this.loading = true;
    console.log(form.value);

    let enquiry = form.value;
    enquiry['company'] = this.company;
    enquiry['branch'] = this.branch;

    this.appServiceManager.post("enquiry", enquiry).subscribe((res: any) => {
      console.log(res);
      if (res && res.status == true) {
        form.reset();
        this.isSuccess = true;
        this.isError = false;
        this.message = "The enquiry has been submitted.";
        this.isMessage = true;
      }
      else {
        this.message = "Sorry, Something went wrong.";
        this.isSuccess = false;
        this.isError = true;
        this.isMessage = true;
      }
      this.loading = false;

    }, (error: any) => {
      this.isMessage = true;
      this.message = "Sorry, Something went wrong.";
      this.loading = false;
      this.isSuccess = false;
      this.isError = true;
    }
    );
  }
  else {
      //  // Form validation error handling
      Object.keys(form.controls).forEach(controlName => {
          const control = form.controls[controlName];
          control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
  }
}
}